import React, { useState } from 'react';
import { Button, Card, Typography, message, Space } from 'antd';
import { MailOutlined, ReloadOutlined, LogoutOutlined } from '@ant-design/icons';
import { useLogout } from '../../hooks/useLogout';
import { useApi } from '../../services/axiosInterceptor';

const { Title, Text } = Typography;

const EmailVerificationPage: React.FC = () => {
  console.info('EmailVerificationPage mounted');
  const [loading, setLoading] = useState(false);
  const { logout } = useLogout();
  const api = useApi();

  const handleResendVerification = async () => {
    console.info('Resend verification email button clicked');
    try {
      setLoading(true);
      const response = await api.post('/auth/resend-email');
      if (response.data.message === "Success") {
        console.log('Verification email resent successfully');
        message.success('Verification email has been resent. Please check your inbox.');
      } else {
        console.warn('Failed to resend verification email:', response.data.message);
        message.error('Failed to resend verification email. Please try again later.');
      }
    } catch (error) {
      console.error('Error resending verification email:', error);
      message.error('Failed to resend verification email. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    console.info('Logout button clicked');
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
      message.error('Failed to logout. Please try again.');
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: '#f0f2f5',
      padding: '20px'
    }}>
      <Card style={{ 
        maxWidth: 500, 
        width: '100%', 
        textAlign: 'center',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        borderRadius: '8px'
      }}>
        <MailOutlined style={{ fontSize: 'clamp(32px, 5vw, 48px)', color: '#0056D2', marginBottom: 24 }} />
        <Title level={2} style={{ fontSize: 'clamp(20px, 4vw, 24px)' }}>Verify Your Email</Title>
        <Text style={{ 
          display: 'block', 
          marginBottom: 24,
          fontSize: 'clamp(14px, 2vw, 16px)'
        }}>
          We've sent a verification link to your email address. Please check your inbox and click the link to verify your account.
        </Text>
        <Text type="secondary" style={{ 
          display: 'block', 
          marginBottom: 32,
          fontSize: 'clamp(12px, 1.5vw, 14px)'
        }}>
          If you haven't received the email, check your spam folder or click the button below to resend the verification link.
        </Text>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={handleResendVerification}
            loading={loading}
            size="large"
            block
          >
            Resend Email
          </Button>
          <Button
            type="default"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            size="large"
            block
          >
            Logout
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default EmailVerificationPage; 
